<input type="text"
       class="bg-gray"
       [(ngModel)]="control.value"
       #name="ngModel"
       [name]="control.name"
       aria-required="true"
       aria-invalid="false"
       [placeholder]="control.placeholder"
       [value]="control.value"
       [required]="control.required"
>
<app-field-error [control]="control" [field]="name"></app-field-error>
